import { CbhFeatureFlag } from "../FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "../FeatureFlags/constants";
import { useCbhFlag } from "../FeatureFlags/useCbhFlag";
import { ATeamHcpStatus } from "./types";

export function useATeamStatus() {
  const {
    status: aTeamStatus,
    isATeamOffExperimentEnabled,
    isATeamDeprecated,
  } = useCbhFlag(CbhFeatureFlag.A_TEAM_HCP, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.A_TEAM_HCP],
  });

  // for this is always TRUE
  const isWorkerAteamEnabled = [ATeamHcpStatus.A_TEAM].includes(aTeamStatus);

  return {
    isWorkerAteamEnabled,
    aTeamStatus,
    isATeamOffExperimentEnabled,
    isATeamDeprecated,
  };
}
